export const getEnvVariable = (name: string) =>
  process.env[name] || process.env[`REACT_APP_${name}`];
